import React, { useEffect, useState, useMemo, useContext } from 'react'
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import HeaderWithButton from '../../Utility/HeaderWithButton';
import TableHeader from '../../Utility/TableHeader';
import { MapPinIcon } from 'lucide-react';
import { Tooltip } from 'react-tooltip';
import { Pagination } from '../../../helper/HelperTwo';
import { DataContext } from '../../../helper/HelperOne';
import Select from "react-select";
import { useExcelDownload, usePDFDownload } from "../../../helper/HelperTwo";

const MissingQuotationLeadList = () => {
    const tabName = localStorage.getItem("tab_name");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [missingQuotationList, setMissingQuotationList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState(null);
    const { searchData } = useContext(DataContext);
    const [filter, setFilter] = useState({
        sales_person: "",
        type_of_work: "",
        labour_name: "",
        sales_service: tabName || "",
        project_manager: "",
        priority: "",
        date_filter: "",
        date_from: "",
        date_to: "",
        create_date_filter: "",
        create_date_from: "",
        create_date_to: "",
    });
    const [salesmanData, setSalesmanData] = useState([]);
    const [workersData, setWorkersData] = useState([]);
    const [typeOfWork, setTypeOfWork] = useState([]);
    const [projectManagerList, setProjectManagerList] = useState([]);
    const [filtersReset, setFiltersReset] = useState(false);
    const [priorityList, setPriorityList] = useState([]);
    const { PDFDownload } = usePDFDownload();
    const { excelDownload } = useExcelDownload();

    const fetchmissingQuotaLead = async (page = 1) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            let url = `public/api/report/leads/quotations-missing?page=${page}`;
            if (searchData) {
                url += `&search=${searchData}`
            }
            if (filter?.sales_service) {
                url += `&sales_service=${filter?.sales_service}`
            }
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            const [
                salesmanResponse,
                typeOfWork,
                workersResponse,
                projectManagerResponse,
                priorityResponse
            ] = await Promise.all([

                axios.get(`public/api/salesmen/list`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get(`public/api/type-of-works/list`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get(`public/api/workers/list`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get(`public/api/project-manager/list`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get(`public/api/priorities/list`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
            ]);

            setProjectManagerList(projectManagerResponse?.data);
            setWorkersData(workersResponse.data);
            setTypeOfWork(typeOfWork?.data);
            setSalesmanData(salesmanResponse?.data);
            setPriorityList(priorityResponse?.data)
            setMissingQuotationList(response?.data?.data?.data)
            setPagination(response?.data.data)
            setCurrentPage(response?.data?.data?.current_page)

        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchmissingQuotaLead();
    }, [searchData])




    const generateBrightColors = (count) => {
        const colors = [];

        for (let i = 0; i < count; i++) {
            const hue = Math.floor(Math.random() * 360); // full range
            const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% bright
            const lightness = Math.floor(Math.random() * 30) + 25; // 25–55% strong colors

            colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
        }

        return colors;
    };

    const colorClasses = generateBrightColors(25);
    const getRandomColorClass = () => {
        return colorClasses[Math.floor(Math.random() * colorClasses.length)];
    };

    const randomColorMap = useMemo(() => {
        const map = {};
        missingQuotationList?.forEach((lead) => {
            lead?.type_of_work?.forEach((work) => {
                if (!map[work.id]) {
                    map[work.id] = getRandomColorClass(); // now returns HSL color
                }
            });
        });
        return map;
    }, [missingQuotationList]);


    const handlePageChange = (page) => {
        if (page !== "...") {
            handleFilter(page);
        }
    };

    const headers = [
        "S No",
        "Enquiry No",
        "Party Name",
        "Mobile No",
        "Contact Person",
        "Sales/Service",
        "Sales Person",
        "Project Manager",
        "Workers ",
        "Type of Work",
        "Priority",
        "City",
        "Created Date",
        "Created Date Difference (One Day)",
        "Next Followup Date",
        "OverDue Days (On Days)",
        "Lead Status",
        "Sync Status",
        "Location",
    ];

    const salesServiceOptions = [
        {
            value: "sales",
            name: "Sales",
        },
        {
            value: "service",
            name: "Service",
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    };


    const handleFilter = async (page = 1) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const queryParams = new URLSearchParams({
                page: page,
                sales_person: filter?.sales_person || "",
                type_of_work: filter?.type_of_work || "",
                labour_name: filter?.labour_name || "",
                sales_service: filter?.sales_service || "",
                project_manager: filter?.project_manager || "",
                priority: filter?.priority || "",
                date_filter: filter?.date_filter,
                date_from: filter?.date_from,
                date_to: filter?.date_to,
                create_date_filter: filter?.create_date_filter,
                create_date_from: filter?.create_date_from,
                create_date_to: filter?.create_date_to,



            }).toString();
            const response = await axios.get(`public/api/report/leads/quotations-missing?${queryParams}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json"
                },
            });

            setMissingQuotationList(response?.data?.data?.data);
            setPagination(response?.data?.data);
            setCurrentPage(response?.data?.data?.current_page);


        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
            setError("Network Failed. Please try again.");
        } finally {
            setLoading(false);

        }
    }

    const handleDownloadPDF = () => {
        const params = {
            sales_person: filter?.sales_person || "",
            type_of_work: filter?.type_of_work || "",
            labour_name: filter?.labour_name || "",
            sales_service: filter?.sales_service || "",
            project_manager: filter?.project_manager || "",
            priority: filter?.priority || "",
            date_filter: filter?.date_filter,
            date_from: filter?.date_from,
            date_to: filter?.date_to,
            create_date_filter: filter?.create_date_filter,
            create_date_from: filter?.create_date_from,
            create_date_to: filter?.create_date_to,
        };

        PDFDownload("report/leads/quotations-missing", "missing-quotations.pdf", params, setLoading);
    };

    const handleDownloadExcel = () => {
        const params = {
            sales_person: filter?.sales_person || "",
            type_of_work: filter?.type_of_work || "",
            labour_name: filter?.labour_name || "",
            sales_service: filter?.sales_service || "",
            project_manager: filter?.project_manager || "",
            priority: filter?.priority || "",
            date_filter: filter?.date_filter,
            date_from: filter?.date_from,
            date_to: filter?.date_to,
            create_date_filter: filter?.create_date_filter,
            create_date_from: filter?.create_date_from,
            create_date_to: filter?.create_date_to,
        };


        excelDownload("report/leads/quotations-missing", "missing-quotations.xlsx", params, setLoading);
    };

    const resetFilters = async () => {
        setLoading(true);
        setFilter({
            sales_person: "",
            type_of_work: "",
            labour_name: "",
            sales_service: tabName || "",
            project_manager: "",
            priority: "",
            priority: "",
            date_filter: "",
            date_from: "",
            date_to: "",
            create_date_filter: "",
            create_date_from: "",
            create_date_to: "",
        });
        setLoading(false);
        setFiltersReset(true);
    };

    useEffect(() => {
        if (filtersReset) {
            fetchmissingQuotaLead(1);
            setFiltersReset(false);
        }
    }, [filtersReset]);


    if (loading) {
        return (
            <div className="h-screen bg-white">
                <div className="flex justify-center items-center h-full">
                    <img
                        className="h-16 w-16"
                        src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
                        alt="loader"
                    />
                </div>
            </div>
        );
    }
    if (error) {
        <div className="h-screen bg-white flex flex-col justify-center items-center">
            <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
            <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => {
                    setError(null); // hide error while retrying
                    fetchmissingQuotaLead(1); // retry API
                }}
            >
                Reload
            </button>
        </div>;
    }
    return (
        <div>

            <HeaderWithButton
                title="Missing Quotation Lead Report"
                description="Missing Quotation Lead "
                buttonText="MissingQuotationLead"
                // onButtonClick={handleAddLead}
                showButton={false}
            />

            <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mt-4">
                {/* Date filter */}

                {/* salesman Dropdown */}
                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Sales Person
                    </label>
                    <Select
                        name="sales_person"
                        options={salesmanData?.map((cust) => ({
                            value: cust.name,
                            label: cust.name,
                        }))}
                        value={
                            salesmanData
                                ?.map((cust) => ({
                                    value: cust.name,
                                    label: cust.name,
                                }))
                                .find((cust) => cust.value === filter.sales_person) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "sales_person",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Sales Person"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Project Manager
                    </label>
                    <Select
                        name="project_manager"
                        options={projectManagerList?.map((cust) => ({
                            value: cust?.name,
                            label: cust?.name,
                        }))}
                        value={
                            projectManagerList
                                ?.map((cust) => ({
                                    value: cust?.name,
                                    label: cust?.name,
                                }))
                                .find((cust) => cust.value === filter?.project_manager) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "project_manager",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Project Manager"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Labour
                    </label>
                    <Select
                        name="worker_tally_id"
                        options={workersData?.map((cust) => ({
                            value: cust.name,
                            label: cust.name,
                        }))}
                        value={
                            workersData
                                ?.map((cust) => ({
                                    value: cust.name,
                                    label: cust.name,
                                }))
                                .find((cust) => cust.value === filter.labour_name) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "labour_name",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Labour"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Type of Work
                    </label>
                    <Select
                        name="type_of_work"
                        options={typeOfWork?.map((work) => ({
                            value: work.name,
                            label: work.name,
                        }))}
                        value={
                            // Find the option where option.value matches filter.type_of_work
                            typeOfWork
                                ?.map((work) => ({ value: work.name, label: work.name }))
                                .find((option) => option.value === filter.type_of_work) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "type_of_work",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Type of Work"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Sales / Service
                    </label>
                    <Select
                        name="sales_service"
                        options={salesServiceOptions?.map((item) => ({
                            value: item.value,
                            label: item.name,
                        }))}
                        value={
                            salesServiceOptions
                                ?.map((item) => ({
                                    value: item.value,
                                    label: item.name,
                                }))
                                .find((option) => option.value === filter.sales_service) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "sales_service",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Sales / Service"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>
                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Priority
                    </label>
                    <Select
                        name="priority"
                        options={priorityList?.map((item) => ({
                            value: item.priority,
                            label: item.priority,
                        }))}
                        value={
                            priorityList
                                ?.map((item) => ({
                                    value: item.priority,
                                    label: item.priority,
                                }))
                                .find((option) => option.value === filter.priority) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "priority",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Priority"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="space-y-3 ">
                    {/* PO Date Select */}
                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Next Followup Date
                        </label>
                        <select
                            name="date_filter"
                            value={filter?.date_filter}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="this_week">This Week</option>
                            <option value="this_month">This Month</option>
                            <option value="this_year">This Year</option>
                            <option value="custom">Custom Range</option>
                        </select>
                    </div>
                </div>

                {filter.date_filter === "custom" && (
                    <>
                        <div className="space-y-3 ">
                            <div className="">
                                <label className="block text-sm font-medium">Date From</label>
                                <input
                                    type="date"
                                    name="date_from"
                                    value={filter.date_from}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                        <div className="space-y-3 ">
                            <div className="w-full">
                                <label className="block text-sm font-medium">Date To</label>
                                <input
                                    type="date"
                                    name="date_to"
                                    value={filter.date_to}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                    </>
                )}

                <div className="space-y-3 ">
                    {/* PO Date Select */}
                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Create Date
                        </label>
                        <select
                            name="create_date_filter"
                            value={filter.create_date_filter}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="this_week">This Week</option>
                            <option value="this_month">This Month</option>
                            <option value="this_year">This Year</option>
                            <option value="custom">Custom Range</option>
                        </select>
                    </div>
                </div>

                {filter.create_date_filter === "custom" && (
                    <>
                        <div className="space-y-3 ">
                            <div className="">
                                <label className="block text-sm font-medium">Date </label>
                                <input
                                    type="date"
                                    name="create_date_from"
                                    value={filter.create_date_from}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                        <div className="space-y-3 ">
                            <div className="w-full">
                                <label className="block text-sm font-medium">Date To</label>
                                <input
                                    type="date"
                                    name="create_date_to"
                                    value={filter.create_date_to}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                    </>
                )}


            </div>

            <div className="flex flex-wrap gap-4 mt-4">
                {/* Submit Button */}
                <button
                    // ref={submitBtnRef}
                    onClick={() => handleFilter(1)}
                    className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
                >
                    Submit
                </button>

                {/* Reset Button */}
                <button
                    onClick={resetFilters}
                    className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                    Reset
                </button>
                <button
                    onClick={handleDownloadPDF}
                    className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                    PDF
                </button>
                <button
                    onClick={handleDownloadExcel}
                    className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                    Excel
                </button>
            </div>

            <div className="overflow-x-auto mt-8">
                <table className="min-w-full border border-gray-300 border-collapse">
                    <TableHeader headers={headers} />
                    <tbody>

                        {missingQuotationList?.length > 0 ? (
                            missingQuotationList?.map((lead, index) => (
                                <tr
                                    key={index}
                                    className="hover:bg-gray-50 transition duration-300 ease-in-out"
                                >
                                    <td className="border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center">
                                        {pagination?.from + index}
                                    </td>

                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.enquiry_no || "N/A"}
                                    </td>

                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.customer_name || "N/A"}
                                    </td>

                                    <td className="border border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5">
                                        <a href={`tel:${lead?.contact_no}`}>
                                            {" "}
                                            {lead?.contact_no || "N/A"}{" "}
                                        </a>
                                    </td>

                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.contact_person || "N/A"}
                                    </td>


                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.sales_service || "N/A"}
                                    </td>
                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.salesman?.name || "N/A"}
                                    </td>
                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.project_manager || "N/A"}
                                    </td>
                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.worker?.name || "N/A"}
                                    </td>

                                    <td className="border border-gray-300 whitespace-wrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.type_of_work && lead?.type_of_work?.length > 0 ? (
                                            <div className="flex flex-wrap gap-2 justify-center">
                                                {lead?.type_of_work?.map((work) => (
                                                    <span
                                                        className="px-3 py-1 border rounded text-xs"
                                                        style={{
                                                            borderColor: randomColorMap[work?.id],
                                                            color: randomColorMap[work?.id],
                                                        }}
                                                    >
                                                        {work?.name || "N/A"}
                                                    </span>
                                                ))}
                                            </div>
                                        ) : (
                                            "N/A"
                                        )}
                                    </td>
                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.priority ?? "N/A"}
                                    </td>
                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead?.city ?? "N/A"}
                                    </td>

                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead.created_at
                                            ? new Date(lead.created_at).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                            })
                                            : "N/A"}
                                    </td>

                                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                                        {lead.createdDayDiff || "0"}
                                    </td>

                                    <td
                                        className={`border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center p-5 ${lead?.next_followup_date
                                            ? (() => {
                                                const today = new Date();
                                                const date = new Date(lead?.next_followup_date);

                                                const todayDate = new Date(
                                                    today.getFullYear(),
                                                    today.getMonth(),
                                                    today.getDate()
                                                );
                                                const compareDate = new Date(
                                                    date.getFullYear(),
                                                    date.getMonth(),
                                                    date.getDate()
                                                );

                                                if (compareDate.getTime() === todayDate.getTime()) {
                                                    return "text-yellow-500"; // Today
                                                } else if (
                                                    compareDate.getTime() < todayDate.getTime()
                                                ) {
                                                    return "text-red-500"; // Past
                                                } else {
                                                    return "text-green-500"; // Future
                                                }
                                            })()
                                            : "text-gray-500"
                                            }`}
                                    >
                                        {lead.next_followup_date
                                            ? new Date(lead.next_followup_date).toLocaleString(
                                                "en-GB",
                                                {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                }
                                            )
                                            : "N/A"}
                                    </td>

                                    <td
                                        className={`border border-gray-300 whitespace-nowrap text-md text-center p-5 sm:pl-4 
                                              ${lead.overdueDays === 0
                                                ? "text-yellow-500" // 0 → yellow
                                                : lead.overdueDays > 0
                                                    ? "text-green-500" // greater than 0 → green
                                                    : "text-gray-500" // less than 0 → red
                                            } `}
                                    >
                                        {lead.overdueDays || "N/A"}
                                    </td>

                                    <td
                                        className={`border border-gray-300 whitespace-nowrap text-md uppercase sm:pl-4 text-center p-5 ${lead.lead_status?.toLowerCase() === "win"
                                            ? "text-green-500"
                                            : lead.lead_status?.toLowerCase() === "loss"
                                                ? "text-red-500"
                                                : lead.lead_status?.toLowerCase() === "followup"
                                                    ? "text-blue-500"
                                                    : "text-gray-500"
                                            }`}
                                    >
                                        {lead.lead_status == "loss"
                                            ? "Lost"
                                            : lead.lead_status || "N/A"}
                                    </td>

                                    <td
                                        className={`border border-gray-300 whitespace-nowrap text-md  ${lead.sync_status == 0 ? "text-red-500" : "text-green-500"
                                            } sm:pl-4 text-center p-5`}
                                    >
                                        {lead.sync_status == 0 ? "Not Synced" : "Synced"}
                                    </td>





                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {lead?.location ? (
                                            <>
                                                <a
                                                    href={lead.location}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="my-anchor-Location text-blue-600 underline inline-flex justify-center"
                                                >
                                                    <MapPinIcon className="h-5 w-5 text-blue-500" />
                                                </a>

                                                <Tooltip
                                                    anchorSelect=".my-anchor-Location"
                                                    place="top"
                                                    className="text-xs p-0"
                                                    style={{ fontSize: "12px", padding: "0.3rem" }}
                                                >
                                                    Location
                                                </Tooltip>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>


                            ))
                        ) : (
                            <tr>
                                <td colSpan={headers.length} className="text-center py-4">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {pagination && (
                <Pagination
                    links={pagination?.links}
                    currentPage={pagination?.current_page}
                    totalResults={pagination?.total}
                    from={pagination?.from}
                    to={pagination?.to}
                    lastPage={pagination?.last_page}
                    onPageChange={handlePageChange}
                />
            )}
        </div>
    )
}

export default MissingQuotationLeadList